import { LoadingOutlined } from '@ant-design/icons';
import { Button, CircularProgress,useMediaQuery } from '@mui/material';
import Typography from '@mui/material/Typography';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { unwrapResult } from '@reduxjs/toolkit';
import { Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Persistor } from '../../../..';
import { NavContext } from '../../../../App';
import SAVIcon from "../../../../GlobalComponents/IconComponents/SAVIcon";
import { Colors } from '../../../../GlobalComponents/Utility/Colors';
import signalRService from '../../../../GlobalComponents/Utility/SignalRConnection';
import { setPaginationModelSAVTT } from '../../../../ReduxTLK/features/Pagination/PaginationsSlice';
import { setFilterModel } from '../../../../ReduxTLK/features/SAV/FilterSlice';
import { resetEditTicketDraftByIndex } from '../../../../ReduxTLK/features/SAV/NewTicketDraftSlice';
import { fetchFilteredTickets } from '../../../../ReduxTLK/features/SAV/TicketSlice';
import { addTab, setLastActiveTab } from '../../../../ReduxTLK/features/Tabs/TabsSlice';
import { fetchUsersAgentSAV } from "../../../../ReduxTLK/features/User/UserSlice";
import routes from "../../../../routes";
import EditSAVTicket from "../../TicketDetails/Edit/EditSAVTicket";
import ViewSAVTicket from "../../TicketDetails/View/ViewSAVTicket";
import CustomFooterComponent from '../CustomFooterComponent';
import ExecuteTicketModal from '../ExecuteTicketModal';
import Filter from '../Filter/Filter';
import { createColumns } from '../TicketColumn';
import './ListAllTickets.css';
import { ticketService } from '../../../../service/ticketService';

const initialNbrsOfTickets = {
  nbrTicketsTotal: 0,
  nbrOuverts: 0,
  nbrEnCours: 0,
  nbrResolus: 0,
  nbrNonResolu: 0,
  nbrClotures: 0,
  nbrAnnules: 0,
  nbrEnAttente: 0
}

export default function ListAllTickets() {
  const isSmallScreen = useMediaQuery('(max-width:800px)');
  const [openFiltreBox, setOpenFiltreBox] = useState(false);
  const [filterOptions, setFilterOptions] = useState({});
  const [dateBegin, setDateBegin] = useState()
  const [dateEnd, setDateEnd] = useState()
  const context = React.useContext(NavContext)
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [pageSize, setPageSize] = useState(12);
  const [page, setPage] = useState(1);
  const [ratios, setRatios] = useState({
    delaiPriseEnChargeMoyen: '--',
    delaiParcouruMoyen: '--',
    delaiResolutionMoyen: '--',
  });
  const [notes, setNotes] = useState({
    "moyenne": 0,
    "nbrNote1": 0,
    "nbrNote2": 0,
    "nbrNote3": 0,
    "nbrNote4": 0,
    "nbrNote5": 0
  })
  const paginationModelSAVTT = useSelector((state) => state.pagination.paginationModelSAVTT);

  const [paginationModelCustom, setPaginationModelCustom] = useState(openFiltreBox ? (paginationModelSAVTT.page ? paginationModelSAVTT : {
    pageSize: 12,
    page: 1,
    nbPage: 1
  }) : (paginationModelSAVTT.page ? paginationModelSAVTT : {
    pageSize: 12,
    page: 1,
    nbPage: 1
  }))
  const [checkboxSelection, setCheckboxSelection] = useState(true);
  const [disableRowSelectionOnClick, setDisableRowSelectionOnClick] = useState(true);
  const toReload = context.tabToBeReloaded

  /*******************save filter form */
  const savedFilterForm = useSelector((state) => state.filter.filter);
  const fetchFiltredModel = useSelector((state) => state.filter.filterModel);
  const filterBoxState = useSelector((state) => state.filter.filterBox);


  useEffect(() => {
    setOpenFiltreBox(filterBoxState);
    dispatch(fetchFilteredTickets(fetchFiltredModel)).then(unwrapResult).then((res) => {
      dispatch(setFilterModel({
        paginationModel: {
          page: res?.data?.pagination?.currentPage,
          pageSize: res?.data?.pagination?.pageSize,
          nbPage: res?.data?.pagination?.nbPage
        },
        body: {
          ...fetchFiltredModel.body
        }
      }))

      setTicketList(res.data.result.tickets);
      setLoading(false);
      Persistor.persist();
    });
  }, []);

  useEffect(() => {
    ticketService.getSavRatios()
      .then((data) => {
        setRatios(data)
      })
      .catch((error) => {
        console.error("Error fetching SAV ratios:", error);
      });
  }, []);



  /***************************** */
  useEffect(() => {
    if (context.tabToBeReloaded?.toString() === 'allTickets') {
      dispatch(fetchFilteredTickets(fetchFiltredModel)).then(unwrapResult).then((res) => {
        dispatch(setFilterModel({
          paginationModel: {
            page: res?.data?.pagination?.currentPage,
            pageSize: res?.data?.pagination?.pageSize,
            nbPage: res?.data?.pagination?.nbPage
          },
          body: {
            ...fetchFiltredModel.body
          }
        }))

        setTicketList(res.data.result.tickets);
        setLoading(false);
        Persistor.persist();
      });
    }
    // Cleanup function
    return () => {
      context.setTabToBeReloaded();
    };
  }, [context.tabToBeReloaded])

  useEffect(() => {
    dispatch(fetchUsersAgentSAV());
  }, [])

  const [ticketList, setTicketList] = useState([])
  const [selectedTicket, setSelectedTicket] = useState('')
  const [nbrsOfTickets, setNbrsOfTickets] = useState(initialNbrsOfTickets);

  const fetchData = async (data) => {
    if ('dateCreation' in filterOptions) {
      delete filterOptions['dateCreation'];
    }
    dispatch(fetchFilteredTickets(data))
      .then(unwrapResult).then((res) => {
        dispatch(setFilterModel({
          paginationModel: {
            page: res?.data?.pagination?.currentPage,
            pageSize: res?.data?.pagination?.pageSize,
            nbPage: res?.data?.pagination?.nbPage
          },
          body: {
            ...fetchFiltredModel.body
          }
        }))

        const {
          nbrTicketsTotal,
          nbrOuverts,
          nbrEnCours,
          nbrResolus,
          nbrNonResolu,
          nbrClotures,
          nbrAnnules,
          nbrEnAttente,
          tickets,
          note
        } = res.data.result;

        setNbrsOfTickets({
          nbrTicketsTotal,
          nbrOuverts,
          nbrEnCours,
          nbrResolus,
          nbrNonResolu,
          nbrClotures,
          nbrAnnules,
          nbrEnAttente
        })

        setNotes(note)

        setTicketList(tickets);
        setLoading(false);
        Persistor.persist();
      });
  };

  const agentsSAV = useSelector((state) => state.user.agentsSAV)

  const getStatutChip = (foundStatut) => {
    if (!foundStatut) {
      return '';
    }
    return (
      <Button
        variant='outlined'
        disabled={true}
        className="status-button"
        style={{
          '--status-color': foundStatut.backgroundColor
        }}
      >
        {foundStatut.nom}
      </Button>
    );
  };

  const [openModal, setOpenModal] = useState(false)

  const handleExecute = (ticket) => {
    setOpenModal(true);
    setSelectedTicket(ticket);
  }

  const handleEdit = (ticket) => {
    openNewTab({ newTab, ticket });
  }

  const handleView = (ticket) => {
    openNewViewTab({ newTabView, ticket });
  }

  const newTab = routes && routes[0]?.pages[1]?.views[2]
  const newTabView = routes && routes[0]?.pages[1]?.views[4];

  function openNewTab(props) {
    setOpenFiltreBox(false)
    const title = '#' + props.ticket;
    const composedId = 'SAV_Ticket_' + props.ticket
    // Find any existing tab with the same ID
    const existingTabIndex = context.tabs.findIndex((tab) => tab.id === composedId);

    // If a tab with the ID already exists, activate it
    if (existingTabIndex !== -1) {
      context.setActiveTab(composedId);
      dispatch(setLastActiveTab(composedId));
      context.setRoomId(props.ticket)
      signalRService.onJoinRoom(props.ticket);
      return; // Exit the function to avoid creating a duplicate tab
    }

    // If no existing tab found, create a new one
    dispatch(resetEditTicketDraftByIndex(props.ticket));
    dispatch(addTab({
      module: 'SAV',
      action: 'Edit',
      identifier: props.ticket,
      id: composedId,
      label: title,
    }));

    context.setTabs([...context.tabs, {
      id: composedId,
      label: title,
      identifier: props.ticket,
      component: <EditSAVTicket id={props.ticket} fetchData={fetchData} paginationModelCustom={paginationModelCustom} />,
      closeable: true,
      icon: <SAVIcon />,
    }]);
    Persistor.persist();
    context.setActiveTab(composedId);
    dispatch(setLastActiveTab(composedId));
    context.setRoomId(props.ticket)
    signalRService.onJoinRoom(props.ticket);
  }

  function openNewViewTab(props) {
    setOpenFiltreBox(false)
    const title = '#' + props.ticket;
    const composedId = 'SAV_Ticket_' + props.ticket
    // Find any existing tab with the same ID
    const existingTabIndex = context.tabs.findIndex((tab) => tab.id === composedId);

    // If a tab with the ID already exists, activate it
    if (existingTabIndex !== -1) {
      context.setActiveTab(composedId);
      dispatch(setLastActiveTab(composedId));
      context.setRoomId(props.ticket)
      signalRService.onJoinRoom(props.ticket);
      return; // Exit the function to avoid creating a duplicate tab
    }

    // If no existing tab found, create a new one
    dispatch(addTab({
      module: 'SAV',
      action: 'View',
      identifier: props.ticket,
      id: composedId,
      label: title,
      closeable: true,
    }));
    Persistor.persist();
    context.setTabs([...context.tabs, {
      id: composedId,
      label: title,
      identifier: props.ticket,
      component: <ViewSAVTicket id={props.ticket} />,
      closeable: true,
      icon: <SAVIcon />,
    }]);
    Persistor.persist();
    context.setActiveTab(composedId);
    dispatch(setLastActiveTab(composedId));
    context.setRoomId(props.ticket)
    signalRService.onJoinRoom(props.ticket);
  }

  const handleRadioChange = (event) => {
    const selectedRowId = event.target.value;
    // Check if the row is already selected
    const isSelected = selectedRows.includes(selectedRowId);

    if (isSelected) {
      // Row is already selected, so remove it from the selectedRows array
      setSelectedRows((prevSelectedRows) =>
        prevSelectedRows.filter((rowId) => rowId !== selectedRowId)
      );
    } else {
      // Row is not selected, so add it to the selectedRows array
      setSelectedRows((prevSelectedRows) => [...prevSelectedRows, selectedRowId]);
    }
  };

  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectionChange = (selection) => {
    setSelectedRows(selection);
  };

  const [height, setHeight] = useState('70vh');

  useEffect(() => {
    setHeight(openFiltreBox ? '35vh' : '70vh')
  }, [openFiltreBox])

  const columns = createColumns(handleView, handleEdit, handleExecute,isSmallScreen)

  // Define the container class based on filter box state
  const containerClass = `tickets-container ${openFiltreBox ? 'tickets-container--with-filter' : ''}`;
  // show only first 3 important columns on small screens and the final one only
  const visibleColumns = isSmallScreen ? columns.filter((col, index) => index < 4 || index === columns.length - 1) : columns;
  return (
    <div className="list-all-tickets-page">
      {loading ? (
        <div className="loading-container">
          <Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} />
        </div>
      ) : (
        <>
          <Filter
            loading={loading}
            setLoading={setLoading}
            fetchData={fetchData}
            setOpenFiltreBox={setOpenFiltreBox}
            setFilterOptions={setFilterOptions}
            dateBegin={dateBegin}
            dateEnd={dateEnd}
            setDateBegin={setDateBegin}
            setDateEnd={setDateEnd}
            openFiltreBox={openFiltreBox}
            setTicketList={setTicketList}
            setPaginationModelCustom={setPaginationModelCustom}
            paginationModelCustom={paginationModelCustom}
            setPaginationModelSAVTT={setPaginationModelSAVTT}

            nbrsOfTickets={nbrsOfTickets}
            ratios={ratios}
            notes={notes}
          />

          <div className={containerClass}>
            <DataGrid
              className="data-grid"
              scroll="paper"
              rows={ticketList}
              columns={visibleColumns}
              page={fetchFiltredModel?.paginationModel?.page}
              setPage={setPage}
              pageSize={fetchFiltredModel?.paginationModel?.pageSize}
              disableSelectionOnClick
              selectionModel={selectedRows}
              onSelectionModelChange={(newSelection) =>
                handleSelectionChange(newSelection.selectionModel)
              }
              editMode={false}
              disableColumnSelector
              slots={{
                pagination: false,
                footer: CustomFooterComponent,
              }}
              slotProps={{
                footer: { fetchFiltredModel, fetchData },
              }}
              rowHeight={53}
              columnHeaderHeight={42}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
              }
              localeText={{
                noRowsLabel: loading ? (
                  <CircularProgress size={24} />
                ) : (
                  <Typography variant="body1">Aucun ticket</Typography>
                ),
              }}
            />
          </div>

          <ExecuteTicketModal
            openModal={openModal}
            setOpenModal={setOpenModal}
            openTicket={selectedTicket}
            fetchData={fetchData}
            paginationModelCustom={fetchFiltredModel}
          />
        </>
      )}
    </div>
  );
}